import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';
import adminSurveyService from '../../services/adminSurveyService';

const AdminAIChatList = ({ surveyId, answersWithTimestamp, isLoading }) => {
    const [chatData, setChatData] = useState([]);
    const [chatLoading, setChatLoading] = useState(true);

    useEffect(() => {
        if (surveyId) {
            fetchChatData();
        }
    }, [surveyId]);

    const fetchChatData = async () => {
        try {
            setChatLoading(true);
            const response = await adminSurveyService.getAllAdminSurveyAnswers(surveyId);
            setChatData(response?.data || []);
        } catch (error) {
            console.error('Error fetching chat data:', error);
            setChatData([]);
        } finally {
            setChatLoading(false);
        }
    };

    if (chatLoading) {
        return (
            <div className="bg-white rounded-lg shadow-sm p-6 mb-6">
                <h2 className="text-xl font-semibold mb-4">AI Chats</h2>
                <div className="space-y-3">
                    {[1, 2, 3, 4, 5].map((i) => (
                        <div key={i} className="animate-pulse">
                            <div className="h-4 bg-gray-200 rounded w-3/4 mb-2"></div>
                            <div className="h-3 bg-gray-200 rounded w-1/2"></div>
                        </div>
                    ))}
                </div>
            </div>
        );
    }

    return (
        <div className="bg-white rounded-lg shadow-sm p-6 mb-6">
            <h2 className="text-xl font-semibold mb-4">AI Chats</h2>

            <div className="overflow-auto max-h-[400px]">
                <table className="w-full">
                    <thead>
                        <tr className="border-b">
                            <th className="py-2 px-1 text-left font-medium text-gray-500">#</th>
                            <th className="py-2 px-1 text-left font-medium text-gray-500">Date</th>
                            <th className="py-2 px-1 text-left font-medium text-gray-500">Status</th>
                            <th className="py-2 px-1 text-left font-medium text-gray-500">Action</th>
                        </tr>
                    </thead>

                    <tbody>
                        {chatData?.length > 0 ? chatData?.map((chat, index) => (
                            <tr key={index} className="border-b">
                                <td className="py-3 px-1 text-[14px]">{index + 1}</td>
                                <td className="py-3 px-1 text-[14px]">{moment(chat?.createdAt).format('YYYY-MM-DD HH:mm')}</td>
                                <td className="py-3 px-1">
                                    <span className={`px-2 py-1 rounded-full text-[10px] ${chat?.order ? "bg-green-100 text-green-800" : "bg-gray-100 text-gray-800"}`}>
                                        {chat.order ? "Ordered" : "Not Ordered"}
                                    </span>
                                </td>
                                <td className="py-3 px-1 text-[13px]">
                                    <Link
                                        to={`/admin/chat/${chat?._id}`}
                                        className="text-[#2962FF] hover:underline font-medium"
                                    >
                                        View Chat
                                    </Link>
                                </td>
                            </tr>
                        )) : (
                            <tr>
                                <td colSpan={4} className='text-center pt-[18px] text-[14px] font-[500] text-gray-500 italic'>
                                    No Chat Found
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default AdminAIChatList;
